import $ from "jquery";
import React from 'react';
import firebase from 'firebase';

import PropTypes from 'prop-types';
import Slide from '@material-ui/core/Slide';
import Radio from '@material-ui/core/Radio';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import CloseIcon from '@material-ui/icons/Close';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Dropdown, Grid, Input, Button, Form, TextArea, Image } from 'semantic-ui-react';


import Tax from './tax';
import './placeorder.css';
import Items from './item'; 
import Combos from './Combo';
import Assembly from './Assembly';
import Followup from './followup';
import Loading from '../../loadings';
import Othercharge from './othercharge';
import QRCode from '../../others/QRCode';
import Webserver from '../../../functions/server';
import TCSValue from '../../../functions/tcsvalue';
import ReadCookie from '../../../functions/readcookies';
import Customerdetails from '../../others/customerdetails';
import { GetWebToken, onMessageListener } from '../../../firebase';
import AssignSparesToService from '../Service/AssignSparesToService';
import Success from './success.gif';

const styles = { appBar: { position: 'relative', }, flex: { flex: 1, }, };

function Transition(props) { return <Slide direction="up" {...props} />; }

class FullScreenDialog extends React.Component {

  state = {
    DiscountLevelOption: [], SelectedDiscountLevel: 0, items: this.props.items, load: false, message: '', state: '', gstn: '', total: 0, modeid: 0, rematk: false, discount: 0,
    otherCharges: '', point: 0, remarks: '', removedItems: this.props.removedData, check1: false, selectedValue: '',
    followupexecutive: '', dueDate: '', customerpoint: 0, lastcustomerpoint: 0, salesType: 'Counter Sale', shipto: true, 
    dname: '', dmobile: '', daddress: '', dtaluk: '', ddistrict: '', dstate: '', dpincode: '', success: Success
  };

  componentDidMount() {
    this.getToday(); this.getBranchs(); 
    this.getDiscountLevel(); 
    if (this.props.remarks) {
      this.setState({ remarks: this.props.remarks })
    } 
    this.getToken();
    onMessageListener().then(payload => {
      this.setState({ openQRCodeDialog: false, paymentSucessDialog: true })
    });
  }

  getDiscountLevel() {
    let context = this;
    context.setState({ load: false, message: 'Getting Discount Level!!!' })
    $.ajax({
      type: 'POST', url: Webserver() + 'WebMaster/DiscountMenu/GetDiscountLevelName.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          let DiscountLevelOption = [
            { key: 'Default', text: 'Default', value: 0 }
          ];
          data.map((c) => {
            DiscountLevelOption.push({ key: c.name, text: c.name, value: c.id })
          })
          context.setState({ DiscountLevel: data, DiscountLevelOption, load: false });
        } catch (e) {
          context.setState({ load: false, DiscountLevel: [] });
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  getToken() {
    let context = this;
    GetWebToken((token) => {
      context.setState({ token })
    });
  }


  handleChangeselect = event => {
    if (event.target.value == 'Credit') {
      this.setState({ selectedValue: event.target.value, followup: true });
    }
    else { this.setState({ selectedValue: event.target.value }); }
  };

  getBranchs() {
    let items = []; let data = (ReadCookie("branch")); let branchname, branchId;
    for (var i = 0; i < data.length; i++) { branchname = data[i].name; branchId = data[i].branch_id; }
    this.setState({ branchname, branchId })
    if (this.props.from == 'edit') { }
    else {
      let placeorderitems; let values = true;
      try {
        placeorderitems = (ReadCookie("placeorderitems"));
      } catch (e) { values = false; }
      if (values == false) { this.setState({ items: [] }) }
      else {
        let partDetails = this.props.partcodeOption;
        partDetails.map((c) => {
          placeorderitems.map((v) => {
            if (c.partno == v.partno && c.brand_id == v.brand) {
              v.uprice = c.mrp; v.tax = c.tax;
            }
          })
        })
        placeorderitems.map((v) => { if (v.partno != 0) { items.push(v); } })
        this.setState({ items })
      }
    }
  }

  getToday() {
    var today = new Date(); var dd = today.getDate(); var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear(); if( dd < 10 ){ dd='0'+dd; }
    if(mm < 10){ mm='0'+mm } today = yyyy+'-'+mm+'-'+dd;
    this.setState({ todayDate: today, expdelivery: today })
  }

  close() { this.setState({ items: [] }); this.props.handleClose(); }

  handleChange = name => event => { this.setState({ expdelivery: event.target.value, }); }

  handleChange1 = name => event => { this.updateItems(event.target.value); }

  addItem = () => {
    let items = this.state.items;
    let largeValue = 0; let id = 0;
    items.map((c) => {
      let cid = c.id;
      try { cid = Number(cid); }
      catch (e) { }
      if (id < cid) { id = cid; }
    })
    id = id + 1;
    items.push({id: id, discountper: this.state.discount, discountrs: 0, orderdetailsId: 0, oldquantity: ''});
    this.setState({ items });
    items = JSON.stringify(items);
    items = JSON.stringify(items);
    this.createCookie('placeorderitems', items, 7);
  }

  createCookie(name,value,days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + ";path=/";
  }

  removeItem(data, removedItems) {
    this.setState({ items: data, removedItems: removedItems });
    data = JSON.stringify(data);
    data = JSON.stringify(data);
    this.createCookie('placeorderitems', data, 7);
  }

  updateItems(discount) {
    let items = this.state.items;
    for (var i = 0; i < items.length; i++) {
      items[i].discount = discount;
    }
    this.setState({ items: items, discount: discount });
    items = JSON.stringify(items);
    items = JSON.stringify(items);
    this.createCookie('placeorderitems', items, 7);
  }

  convertToNumber(value) {
    try { value = Number(value); }
    catch (e) { value = 0; }
    return value;
  }

  convertToFloat(value) {
    try { value = parseFloat(value); }
    catch (e) { value = 0; }
    return value;
  }

  updateItem = (id, type, value) => {
    let items = [];
    if (this.state.type == 'edit') { items = this.state.items; }
    else { items = this.state.items; }
    let total = 0;
    if (type == 'quantity') {
      let duplicate = 0; let partno = 0; let brand = 0;
      items.map((c) => { if (c.id == id) { partno = c.partno; brand = c.brand; } })
      items.map((b) => { if (b.id != id && partno == b.partno && brand == b.brand) { duplicate = 1; } })
      if (duplicate == 1) {
        alert(partno+' is Duplicate Entry');
        return;
      }
    }

    for (var i = 0; i < items.length; i++) {
      if (items[i].id == id) {
        // if (type == 'quantity') {
        //   items[i]['discountper'] = 0; items[i]['discountrs'] = 0;
        // }
        items[i][type] = value;
        let quantity = this.convertToNumber(items[i]['quantity']);
        let uprice = this.convertToNumber(items[i]['uprice']);
        let discountrs = this.convertToFloat(items[i]['discountrs']);
        let discountper = this.convertToFloat(items[i]['discountper']);
        let tax = this.convertToFloat(items[i]['tax']);
        if (type == 'discountrs') {
          uprice = uprice + ((uprice * tax)/100);
          let totalPrice = uprice * quantity;
          let discountPrice = totalPrice - (totalPrice - value);
          let discount = discountPrice/totalPrice * 100;
          items[i]['discountper'] = discount;
        }
        if (type == 'discountper') {
          items[i]['discountrs'] = ((((uprice * quantity) + (((uprice * quantity) * tax)/100)) * value)/100);
        }
        if (type == 'quantity') {
          uprice = uprice + ((uprice * tax)/100);
          discountrs =  uprice * quantity;
          discountrs = (discountrs * discountper)/100;
          items[i]['discountrs'] = discountrs;
        }
      }
    }
    this.setState({ items: items })
    items = JSON.stringify(items);
    items = JSON.stringify(items);
    this.createCookie('placeorderitems', items, 7);
  }

  pointchanges = (type) => (f, { value }) => {
    let last = Number(this.state.lastcustomerpoint);
    value = Number(value);
    if (value == 0) {
      let items = this.state.items;
      items.map((x) => { x.discountper = 0; x.discountrs = 0; });
      this.setState({ items: items, customerpoint: 0});
      items = JSON.stringify(items);
      items = JSON.stringify(items);
      this.createCookie('placeorderitems', items, 7);
    }
    else {
      value = value - last;
      if (value < 0) { alert('No Nagative Points'); return; }
      if (value > this.props.customerPoints) {
        alert('Point is greater then available points');
        return;
      }
      let items = this.state.items; let tenPER = 0;
      for (var i = 0; i < items.length; i++) {
        if (items[i].status == 'Othercharge') { }
        else {
          let mrps = Number(items[i].uprice) *  Number(items[i].quantity);
          tenPER = tenPER + ((mrps * 10)/100);
        }
      }
      tenPER = Math.round(tenPER);
      if (tenPER < value) { alert('Below '+tenPER+' Points are acceptable'); return; }
      let customerpoint = value;
      items.map((s) => {
        let tax = Number(s.tax);
        let itemTenPER = Number(s.uprice) *  Number(s.quantity);
        itemTenPER = (itemTenPER * 10)/100;
        if (s.status == "Othercharge") { }
        else {
          if (customerpoint == 0) { }
          else {
            if (itemTenPER <= customerpoint) {
              s.discountper = 10; s.discountrs = itemTenPER;
              customerpoint = customerpoint - itemTenPER;
            }
            else {
              let originalPrice = Number(s.uprice); let quantity = Number(s.quantity);
              let totalCost = originalPrice * quantity;
              let perCentage = 100 - (((totalCost - customerpoint)/totalCost) * 100);
              s.discountper = perCentage; s.discountrs = customerpoint; customerpoint = 0;
            }
          }
        }
      })
      this.setState({ items: items, customerpoint: value, lastcustomerpoint: customerpoint });
      items = JSON.stringify(items); items = JSON.stringify(items); this.createCookie('placeorderitems', items, 7);
    }
  }

  changes = (type) => (f, { value }) => {
    if (type == 'point') { if (value < 0) { alert('No Nagative Points'); return; } }
    this.setState({ [type]: value });
  }

  otherChangesUpdate(items) {
    this.setState({ items: items }); 
    items = JSON.stringify(items);
    items = JSON.stringify(items);
    this.createCookie('placeorderitems', items, 7);
  }

  convertToNumber(id) {
    try { id = Number(id); }
    catch (e) { id = 'Enter Customer Name Properly'; }
    return id;
  }

  qtyChecking() {
    let items = this.state.items;
    let value = 0;
    items.map((c) => {
      if (c.partno != "0") {
        let avaStocks = this.convertToNumber(c.ava_stocks);
        let quantity = this.convertToNumber(c.quantity);
        if (avaStocks < quantity) {
          value = 1;
        }
      }
    });
    return value;
  }

  generateQuatationAndInvoice(type) {
    let { shipto, otherCharges, modeid, selectedValue, expdelivery, dueDate, remarks, followupexecutive, point, items, branchId } = this.state;
    let paymentMode = selectedValue;
    let branch = branchId;
    let qtyCheck = 0;
    if (type == 'invoice') {
      qtyCheck = this.qtyChecking();
      if (qtyCheck != 0) { alert('Please remove Negative stock entry!!!'); return; }
    }
    let id = this.props.customer;
    let checkDetails = false;
    items.map((x) => {
      if (x.status != 'Othercharge') {
        if (x.quantity == '' || x.quantity == 0 || x.quantity == null || x.quantity == undefined) {
          checkDetails = true;
        }
        if (x.partno == '' || x.partno == 0 || x.partno == null || x.partno == undefined) {
          checkDetails = true;
        }
      }
    })
    if (checkDetails == true) { alert('Enter the All Details Properly!!!'); return; }
    items.map((c) => {
      let quantity = 0; let uprice = 0;
      let discountPercentage = 0; let tax = 0;
      try {
        quantity = Number(c.quantity); tax = Number(c.tax);
        uprice = Number(c.uprice); discountPercentage=Number(c.discountper);
      } catch (e) { }
      let sum = uprice * quantity;
      let ss = sum - ((sum * discountPercentage)/100);
      let discountPrice = ((uprice - ((uprice * discountPercentage)/100)) * quantity);
      let taxPrice = ((discountPrice * tax)/100);
      let taxables = (Number(discountPrice) + Number(taxPrice));
      c.totprice = taxables; c.tax = tax;
    })

    if (items.length == 0) { alert('please enter the items!!!'); return; }
    if (this.props.from == 'edit') { this.updateData(type, items); }
    else {
      if (paymentMode == 'Credit') { modeid = 0; }
      if (paymentMode == 'Online') { modeid = 0; }
      let context = this; 
      if (dueDate == undefined || followupexecutive == undefined) {
        dueDate = ''; followupexecutive = '';
      }
      if (point < 0) { alert('No nagative points!!!'); return; }
      if (this.state.ordertype == 'save' || this.state.ordertype == 'quotation') { }
      else {
        if (paymentMode == '' || paymentMode == undefined || paymentMode == null) {
          alert('Enter Payment Mode'); return;
        }
      }
      let cook = (ReadCookie("vaigai"));
      let by = cook.id; let emptyData = [];
      items.map((v) => { v.branch = branch })
      let auditCheck = 0;
      items.map((c) => {
        if (c.status != "Othercharge") {
          auditCheck = 1;
        }
      })
     
      let newPartItem = [];
      items.map((c) => { if (c.uprice) { newPartItem.push(c); } })

      let newItemsWithTCSCheck = [];
      if (this.props.customerTCS == '0' || this.props.customerTCS == 0) {
        newPartItem.map((c) =>  { if (c.partname != 'TCS') { newItemsWithTCSCheck.push(c); } })
      }
      else {
        newItemsWithTCSCheck = newPartItem;
      }
      items = JSON.stringify(newItemsWithTCSCheck);
      let customerReedemPoints = Number(this.state.customerpoint * -1);
      
      let executiveId = this.props.executiveId;
      
      if (shipto) { shipto = 1 }
      else { shipto = 0; }
      if (shipto == 0) {
        if (!this.state.dname || !this.state.dmobile || !this.state.daddress || !this.state.dtaluk || 
          !this.state.ddistrict || !this.state.dstate) {
          alert('Please Enter All Delivery Details!!!');
          return;
        }
      }
      let data1 = { 'type': type, 'otherCharges': otherCharges, 'id': id, 'by': by, 'order': items, 'expdelivery': expdelivery, 'remarks': remarks,
                    'd_location': branch, 'point': point, 'paymentMode': paymentMode, 'paymentmodeid': modeid, 'executiveId': executiveId, 'platform': 1,
                    'followupexecutive': followupexecutive, 'dueDate': dueDate, 'redeenpointcheck': this.state.check1, 'customerpoint': customerReedemPoints,
                    'salesType': this.state.salesType, 'shipto': shipto, 'dname': this.state.dname, 'dmobile': this.state.dmobile, 'daddress': this.state.daddress, 
                    'dtaluk': this.state.dtaluk, 'ddistrict': this.state.ddistrict, 'dstate': this.state.dstate, 'dpincode': this.state.dpincode };
      context.setState({ load: true, message: 'Place Order!!!' });  
      $.ajax({ type: 'POST', data: data1,
        url: Webserver() + 'placeorder/insert.php',
        success: function(data) { 
         console.log(data);
          if (data == 0) {
            context.setState({ load: false, selectedValue: '' }); alert('Failed!!!'); return;
          }
          try {
            data = Number(data);
            if (typeof data == 'number') {
              context.setState({ load: false, selectedValue: '' }); emptyData = [];
              context.createCookie('placeorderitems', emptyData, 7);
              if (type == 'invoice') {
                let openQRCodeDialog = true;
                if (paymentMode == 'Credit') { openQRCodeDialog = false; }
                context.setState({
                  remark: false, items: [], dueDate: '', otherCharges: 0,
                  customerpoint: 0, ordertype: '', point: 0, followupexecutive: '',
                  remarks: '', dueDate: ''
                });
                modeid = Number(modeid);
                if (modeid > 1) {
                  context.props.handleClose1(data, type);
                }
                else {
                  if (openQRCodeDialog) {
                    context.generateQRCode(data);
                  }
                  else {
                    context.props.handleClose1(data, type);
                  }
                }
                emptyData = [];
                context.createCookie('placeorderitems', emptyData, 7);
                let open = Webserver() + "pdf/placeorderpdf2.php?quotationId="+data+"&customerId="+id+"&bankId=0";
                window.open(open);
              }
              else {
                context.setState({
                  remark: false, items: [], dueDate: '', otherCharges: 0,
                  customerpoint: 0, ordertype: '', point: 0, followupexecutive: '',
                  remarks: '', dueDate: ''
                });
                emptyData = [];
                context.createCookie('placeorderitems', emptyData, 7);
                let open = Webserver() + "pdf/placeorderpdf2.php?quotationId="+data+"&customerId="+id+"&bankId=0";
                window.open(open);
              //  context.props.handleClose1(data, type);
              }
            }
          } catch (e) { alert('Error!!'); context.setState({ load: false }); }
        }, error: function(err) { context.setState({ load: false, }); }
      })
    }
  }

  updatefollowupDetails(dueDate, followup) {
    this.setState({ dueDate: dueDate, followupexecutive: followup, followup: false })
  }

  updateData(type, items) {
    let context = this; let quotationId = this.props.quotationId; let removedItems = this.state.removedItems;
    quotationId = Number(quotationId);
    let auditCheck = 0;
    if (type != 'quotation') {
      items.map((c) => { 
        if (c.status != "Othercharge") {
          if (c.adjstock != 0) {
            console.log(c);
            alert(c.adjstock)
            alert(c.partno+' this spare in audit....Please Clear and Place Order');
            auditCheck = 1;
          } 
        } 
      }) 
    }
    if (auditCheck == 1) {
      return;
    }
    let otherCharge = [];
    let updateItems = [];
    items.map((c) => {
      if (c.status == 'Othercharge') {
        otherCharge.push(c);
      }
      else {
        updateItems.push(c);
      }
    })
    let newItemsWithTCSCheck = [];
    if (this.props.customerTCS == '0' || this.props.customerTCS == 0) {
      items.map((c) =>  {
        if (c.partname != 'TCS') {
          newItemsWithTCSCheck.push(c);
        }
      })
    }
    else {
      newItemsWithTCSCheck = items;
    }

    let newItemArray = [];

    newItemsWithTCSCheck.map((c) => { 
      newItemArray.push({ 
        partno: c.partno, quantity: c.quantity, oldquantity: c.oldquantity,
        totprice: c.totprice, tax: c.tax, uprice: c.uprice, partname: c.partname,
        point: c.point, brand: c.brand, status: c.status, discountper: c.discountper,
        discountrs: c.discountrs, orderdetailsId: c.orderdetailsId, rackno: c.rackno
      })
    })

    items = JSON.stringify(newItemArray); otherCharge= JSON.stringify(otherCharge); removedItems = JSON.stringify(removedItems); let masterId = this.props.masterId;
    let point = this.state.point; let customerId = this.props.customerId; let paymentMode = this.state.selectedValue;
    let modeid = this.state.modeid; let remarks = this.state.remarks; let customerReedemPoints = "-"+this.state.customerpoint;
    let executiveId = this.props.executiveId; let expdelivery = this.state.expdelivery; let emptyData = [];
    let data = (ReadCookie("branch")); let branch; for (var i = 0; i < data.length; i++) { branch = data[i].branch_id; }
    customerReedemPoints = Number(customerReedemPoints);


    if (paymentMode == 'Credit') { modeid = 0; } let cook = (ReadCookie("vaigai"));
    let by = cook.id; let dueDate = this.state.dueDate; let followupexecutive = this.state.followupexecutive;

    let shipto = this.state.shipto;
    if (shipto) { shipto = 1 }
    else { shipto = 0; }
    if (shipto == 0) {
      if (!this.state.dname || !this.state.dmobile || !this.state.daddress || !this.state.dtaluk || 
        !this.state.ddistrict || !this.state.dstate) {
        alert('Please Enter All Delivery Details!!!');
        return;
      }
    }



    let data1 = { 'quotationId': quotationId, 'masterId': masterId, 'customerId': customerId, 
                  'branch': branch, 'platform': 1, 'by': by, 'executiveId': 0, 
                  'followupexecutive': followupexecutive, 
                  'dueDate': dueDate, 'paymentMode': paymentMode, 'remarks': remarks, 
                  'customerReedemPoints': customerReedemPoints, 
                  'paymentmodeid': modeid, 'expdelivery': expdelivery, 
                  'ordertype': type, 
                  'point': point, 'items': items, 
                  'removedItems': removedItems,
                  'shipto': shipto, 'dname': this.state.dname, 'dmobile': this.state.dmobile, 
                  'daddress': this.state.daddress, 'dtaluk': this.state.dtaluk, 
                  'ddistrict': this.state.ddistrict, 'dstate': this.state.dstate, 
                  'dpincode': this.state.dpincode
                };
                items = JSON.parse(items);
                removedItems = JSON.parse(removedItems);
                console.log('items');
    console.log(items);
    console.log('removed items');
    console.log(removedItems);
    context.setState({ load: false, message: 'Place Order!!!', });
    $.ajax({ type: 'POST', data: data1,
      url: Webserver() + 'placeorder/update.php',
      success: function(data) {
        console.log(data);
        let openQRCodeDialog = true;
        if (paymentMode == 'Credit') { openQRCodeDialog = false; }
        context.setState({
          load: false, selectedValue: '', remark: false, items: [], dueDate: '', otherCharges: 0, customerpoint: 0, ordertype: '',
          point: 0, followupexecutive: '', remarks: '', dueDate: ''
        });
        emptyData = [];
        context.createCookie('placeorderitems', emptyData, 7);
        if (data == 1 || data == '1') {
          context.props.updateAndClose();
          if (type == 'invoice') {
            let open = Webserver() + "pdf/placeorderpdf2.php?quotationId="+quotationId+"&customerId="+customerId+"&bankId=0";
            window.open(open);
            if (modeid > 1) {
            }
            else {
              if (openQRCodeDialog) {
                context.generateQRCode(quotationId);
              }
            }
          }
          else { context.props.updateAndClose(); }
        }
      },
      error: function(err) { }
    })
  }

  AddArrayValues(items) {
    this.setState({ items: items }); items = JSON.stringify(items);
    items = JSON.stringify(items);
    this.createCookie('placeorderitems', items, 7);
  }

  clearData() {
    let items = [];
    this.setState({ items: items, removedItems: this.state.items })
    items = JSON.stringify(items); items = JSON.stringify(items); this.createCookie('placeorderitems', items, 7);
  }

  handleChangeCheck = name => event => {
    if (name == 'check') {
      if (event.target.checked) { this.setState({ [name]: event.target.checked, point: 1 }); }
      else { this.setState({ [name]: event.target.checked, point: 0 }); }
    }
    else { this.setState({ [name]: event.target.checked }); }
  };

  paymentdropdown = event => {
    let value = event.target.value; let dropdown =  event.target.value;
    let modeid = value.split('->')[0]; let mode = value.split('->')[1];
    this.setState({ selectedValue: mode, modeid: modeid, })
  }

  selectedSalesType = (f, { value }) => { console.log(value); this.setState({ salesType: value }) }

  generatePicklist() {
    let items = this.state.items;
  }

  generateQRCode(quotationId) {
    let context = this;
    $.ajax({
      type: 'POST', data: { quotationId, 'token': this.state.token },
      url: Webserver() + 'quotation/getAmountAndComments.php',
      success: function(data) {
        console.log(data);
        let amount = 0;
        let comments = '';
        try {
          data = JSON.parse(data);
          data.map((c) => { amount = c.amount; comments = c.comments; })
          let url = "https://vaigaiclaas.com/pay?amount="+amount+"&tn="+comments+"&q="+quotationId;
          context.setState({ openQRCodeDialog: true, url })
        } catch (e) {
          alert('Error TO Generate QRCode');
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }

  closeQRcode() {
    this.setState({ openQRCodeDialog: false, paymentSucessDialog: true }); 
    if (this.props.from == 'edit') {
      this.props.updateAndClose(); 
    }
  }

  refreshAfterMovingSparesToService = () => {
    let items = [];
    items = JSON.stringify(items);
    this.setState({ items: [], dialog: false })
    items = JSON.stringify(items);
    this.createCookie('placeorderitems', items, 7);
 
  }


  changeDiscountLevel = (f, { value }) => {
    this.setState({ SelectedDiscountLevel: value });
    this.props.getPartCode(value)
    this.clearData();
  }

  render() {
    let salesTypeOption = [
      {key: 'Wholesale', text: 'Wholesale', value: 'Wholesale'},
      {key: 'Counter Sale', text: 'Counter Sale', value: 'Counter Sale'},
      {key: 'Paid(Service)', text: 'Paid(Service)', value: 'Paid(Service)'},
      {key: 'Warranty(Service)', text: 'Warranty(Service)', value: 'Warranty(Service)'},
    ]
    let branch; let branchDetails = (ReadCookie("branch"));
    for (var i = 0; i < branchDetails.length; i++) { branch = branchDetails[i].branch_id; }
    let customerRedeemPoints = this.props.customerPoints;
    try {
      customerRedeemPoints = Number(customerRedeemPoints).toFixed(2);
    } catch (e) {
    }
    let itemdata= this.state.items; const { fullScreen } = this.props;
    const { classes } = this.props; let maxDate = this.state.todayDate;
    let count = 0; let weight = 0; let points = 0;
    let items = itemdata.map((x) => {
      console.log(x);
      if (x.status == "Othercharge" || x.partnumber == '0') { }
      else {
        let wei = x.weight; let point = x.point; let quantity = x.quantity; let uprice = x.uprice;
        let discountPercentage = x.discountper; let tax = x.tax; uprice = Number(uprice); tax = Number(tax);
        discountPercentage = Number(discountPercentage); wei = Number(wei); point = Number(point);
        quantity = Number(quantity); weight = weight + (wei * quantity); let discountPrice = ((uprice - ((uprice * discountPercentage)/100)) * quantity).toFixed(2);
        let taxPrice = ((discountPrice * tax)/100).toFixed(2); let totprice = (Number(discountPrice) + Number(taxPrice)).toFixed(2); points = points + (totprice * point)/100; count++;
        return (
          <Items discount={x.discountper} count={count} id={x.id} remove={this.removeItem.bind(this)} allData={x} allItems={this.state.items}
           setPartcode={this.props.setPartcode} type={this.props.type} updateItem={this.updateItem.bind(this)} branch={branch} dis={this.state.discountper}
           total={x.totprices} itemdata={this.props.partcode} addItem={this.addItem.bind(this)} removedItems={this.state.removedItems}
           partcodeOption={this.props.partcodeOption} partcodeData={this.props.partcode} AddArrayValues={this.AddArrayValues.bind(this)} />
        );
      }
    })
    let options = [ { key: 'Discount %', text: 'Discount %', value: 'per' }, { key: 'Discount Rs.', text: 'Discount Rs.', value: 'rs' } ];
    return (
      <div>
      <Loading load={this.state.load} message={this.state.message} />
        <Dialog fullScreen
          open={this.props.dialog} onClose={this.close.bind(this)}
          TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={this.close.bind(this)} aria-label="Close"> <CloseIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" className={classes.flex}> Place Order </Typography>
              {this.state.branchname}
            </Toolbar>
          </AppBar>
          <div style={{padding: '0.5%'}}>
            { this.props.type == 'edit' ?
              ( <div></div> ) :
              (
                <div style={{display: 'flex', marginBottom: 10, width: '100%'}}>
                  <div style={{marginLeft: 10, width: '12%'}}>
                    Expected Delivary Date<br/>
                    <input type="date" min={maxDate} id="date" value={this.state.expdelivery}
                      style={{width: '100%', height: 35 }} onChange={this.handleChange('date')} />
                  </div>
                  <div style={{marginLeft: 10, width: '10%'}}>
                    Discount<br/>
                    <Input fluid focus type='number' onChange={this.handleChange1('discount')}
                    value={this.state.discount} />
                  </div>
                  
                  <div style={{marginLeft: 10, width: '18%'}}>
                    Selected Discount Level<br/>
                    <Dropdown placeholder='Selected Discount Level' 
                    style={{ borderColor: '#5A9CBB'}}
                      fluid search selection onChange={this.changeDiscountLevel}
                      options={this.state.DiscountLevelOption} value={this.state.SelectedDiscountLevel} />
                  </div>
                  <div style={{marginLeft: 10, width: '15%'}}>
                    <br/>
                    <div style={{marginTop: '2%'}}>
                      <Combos save={ (name, value) => { this.setState({ [name]: value }) } } items={this.state.items} partcode={this.props.partcode} branchId={this.state.branchId} />
                    </div>
                  </div>
                  <div style={{ marginLeft: 10, width: '15%'}}>
                    <br/>
                    <div style={{marginTop: '2%'}}>
                      <Assembly save={ (name, value) => { this.setState({ [name]: value }) } } items={this.state.items} partcode={this.props.partcode} branchId={this.state.branchId} />
                    </div>
                  </div>
                  <div style={{marginLeft: 10, width: '25%', marginTop: '2%'}}>
                    <table id="table" width="100%">
                      <tr>
                        <th id="th">Customer Detail</th>
                        <th id="th">Order Point</th>
                        <th id="th">Order Weight</th>
                      </tr>
                      <tr>
                        <td>
                          <Customerdetails customerId={this.props.customer} customerName={this.props.customerName} from={'placeorder'} />
                        </td>
                        <td>
                          <center>{points.toFixed(1)}</center>
                        </td>
                        <td>
                          <center>{weight}</center>
                        </td>
                      </tr>
                    </table>
                  </div>
                  
                  
                  
                </div>
              )
            }
          <Grid>
            <Grid.Column mobile={16} tablet={16} computer={16}>
            { itemdata.length > 0 ?
              (
                <div>
                  <table id="table" width="100%">
                    <tr>
                      <th id='tableheader' style={{width: '2%'}}><center>#</center></th>
                      <th id='tableheader' style={{width: '25%'}}><center>Select Partcode</center></th>
                      <th id='tableheader' style={{width: '9%'}}><center>Brand</center></th>
                      <th id='tableheader' style={{width: '5%'}}><center>Rackno</center></th>
                      <th id='tableheader' style={{width: '8%'}}><center>Quantity</center></th>
                      <th id='tableheader' style={{width: '7.5%'}}><center>Disc(%)</center></th>
                      <th id='tableheader' style={{width: '8'}}><center>Disc(Rs)</center></th>
                      <th id='tableheader' style={{width: '8%'}}><center>Discount Unit Price (Rs.)</center></th>
                      <th id='tableheader' style={{width: '7.5%'}}><center>Disc<br/> Price (Rs.)</center></th>
                      <th id='tableheader' style={{width: '7%'}}><center>Tax<br/> Price (Rs.)</center></th>
                      <th id='tableheader' style={{width: '8%'}}><center>Taxable<br/> Amount (Rs.)</center></th>
                      <th id='tableheader' style={{width: '5%'}}><center></center></th>
                    </tr>
                    {items}
                  </table>
                  <div>
                    <u style={{color: '#6E96D3'}} id="pointer" onClick={this.clearData.bind(this)}>Clear Data</u>
                  </div>
                </div>
              ) : ( <div></div> )
              }
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={8}>
              { itemdata.length > 0 ?
                (<div>
                    
                    <Othercharge removedItems={this.state.removedItems}
                    updateDynamicState={ (type, value) => this.setState({ [type]: value }) }
                    customerTCS={this.props.customerTCS} items={this.state.items} 
                    otherChargeinfo={this.props.otherChargeinfo} otherCharge={this.props.otherCharge} 
                    otherChargeAmount={this.props.otherChargeAmount} otherChargeTax={this.props.otherChargeTax} 
                    otherChangesUpdate={this.otherChangesUpdate.bind(this)} />
                    <br/>
                    <Form>
                      <TextArea placeholder='Remark...' onChange={this.changes('remarks')}
                       value={this.state.remarks}/>
                    </Form>
                  </div> ) : ''
              }
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={8}>
              { itemdata.length > 0 ?
                (<Tax branchState={this.props.branchState} customerTCS={this.props.customerTCS} 
                  taxsystem={this.state.taxsystem} purchaseState={this.props.customerState} data={this.state.items} />
                ) : ''
              }
              <div>

                    <div>
                      <div style={{display: 'flex'}}>
                <Checkbox checked={this.state.shipto} onChange={this.handleChangeCheck('shipto')}
                  value="Ship To Same Billing Address" />
                <div style={{paddingTop: '2.5%'}}>Ship To Same Billing Address</div>
              </div>
              { this.state.shipto ? '' : 
                (
                  <div>
                    <center>Delivery Details</center>
                    <div style={{display: 'flex'}}>
                      <div style={{width: '50%'}}>
                        Name
                        <Input onChange={this.changes('dname')} value={this.state.dname} style={{width: '100%'}}/>
                      </div>
                      <div style={{width: '50%'}}>
                        Mobile Number
                        <Input onChange={this.changes('dmobile')} value={this.state.dmobile} style={{width: '100%'}}/>
                      </div>
                    </div> 
                    Address
                    <TextArea onChange={this.changes('daddress')}  maxLength="120" value={this.state.daddress} style={{width: '100%'}}/>
                    <div style={{display: 'flex'}}>
                      <div style={{width: '50%'}}>
                        Taluk
                        <Input onChange={this.changes('dtaluk')} value={this.state.dtaluk} style={{width: '100%'}}/>
                      </div>
                      <div style={{width: '50%'}}>
                        District
                        <Input onChange={this.changes('ddistrict')} value={this.state.ddistrict} style={{width: '100%'}}/>
                      </div>
                    </div>
                    <div style={{display: 'flex'}}>
                      <div style={{width: '50%'}}>
                        State
                        <Input onChange={this.changes('dstate')} value={this.state.dstate} style={{width: '100%'}}/>
                      </div>
                      <div style={{width: '50%'}}>
                        Pincode
                        <Input onChange={this.changes('dpincode')} value={this.state.dpincode} style={{width: '100%'}}/>
                      </div>
                    </div>
                  </div>
                )
              }
                    </div>
                  
              </div>
              
            </Grid.Column>
          </Grid>
          { this.props.type == 'edit' ?
            (
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Button positive fluid onClick={this.addItem}>Add</Button>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={4}>
                  <Button fluid>Cancel</Button>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={4}>
                  <Button positive fluid onClick={this.updateData.bind(this)}>Update</Button>
                </Grid.Column>
              </Grid>
            ) : (
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={4}>
                  <Button positive fluid onClick={this.addItem}>Add</Button>
                </Grid.Column>
                { this.props.fromDisplay == 'none' ?
                  (
                    <Grid.Column mobile={16} tablet={16} computer={4}>
                      <Button primary fluid onClick={ () => { this.setState({ remark: true, ordertype: 'quotation' }) }}>SAVE</Button>
                    </Grid.Column>
                  ):
                  (
                    <Grid.Column mobile={16} tablet={16} computer={4}>
                      <Button primary fluid onClick={ () => { this.setState({ remark: true, ordertype: 'quotation' }) }}>Quotation</Button>
                    </Grid.Column>
                  )
                }
                <Grid.Column mobile={16} tablet={16} computer={4}>
                  <Button primary fluid onClick={ () => { this.setState({ remark: true, ordertype: 'invoice' }) }}>Invoice</Button>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={4} style={{display: this.props.fromDisplay}}>
                  <Button primary fluid onClick={ () => { this.setState({ remark: true, ordertype: 'save' }) }}>Save</Button>
                </Grid.Column>
              </Grid>
            )
          }
          </div>
        </Dialog>


        <Dialog fullScreen={fullScreen} open={this.state.openQRCodeDialog} aria-labelledby="responsive-dialog-title" >
          <DialogContent>
            <QRCode close={this.closeQRcode.bind(this)} size={250} level={'L'} value={this.state.url} />
          </DialogContent>
        </Dialog>


        <Dialog fullScreen={fullScreen} open={this.state.paymentSucessDialog} aria-labelledby="responsive-dialog-title" >
          <DialogContent style={{height: 250, width: 300}}>
            <center><h2>Payment Success!!!</h2></center>
            <Image src={this.state.success} size='small' id='imagess'
                      style={{width: '100%', height: '100%', cursor: 'pointer'}} />
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ paymentSucessDialog: false }); }}>Close</Button>
          </DialogActions>
        </Dialog>


        <Dialog fullScreen={fullScreen} open={this.state.remark} aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 500}}> {"Add Remark & Conform Order"} </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <div>
                <Grid>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    { (this.state.ordertype == 'save' || this.state.ordertype == 'quotation') ?
                      (<div><center>Save Orders</center></div>) : (<div></div>)
                    }
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                  { (this.state.ordertype == 'invoice') ?
                     (
                       <div>
                         <Checkbox checked={this.state.check} onChange={this.handleChangeCheck('check')}
                           value="Check" /> Reward Point
                         { this.state.check ?
                           (
                             <div style={{display: 'flex'}}>
                               <Input type="number" onChange={this.changes('point')}
                                  value={this.state.point} style={{width: 100}}/>
                                <br/>
                               <b style={{paddingTop: '3%', fontSize: 18}}>{" X "}</b>
                               <b style={{paddingTop: '3%', fontSize: 18}}>{points.toFixed(1)+' =  '}</b>
                               <b style={{paddingTop: '3%', fontSize: 18}}>{(points.toFixed(1) * this.state.point).toFixed(1)}</b>
                             </div>
                           ) : ( <div></div> )
                         }
                       </div>
                     ) : ( <div></div> )
                  }
                  <br/>
                  { (this.state.ordertype == 'invoice') ?
                     (
                       <div>
                         <Checkbox checked={this.state.check1} onChange={this.handleChangeCheck('check1')}
                           value="Check1" /> {'Redeem Point'}
                         { this.state.check1 ?
                           (
                             <div>
                              <b>{customerRedeemPoints+' Point`s available'}</b><br/>
                              <Input type="number" onChange={this.pointchanges('total')} value={this.state.customerpoint} style={{width: 100}}/>
                             </div>
                           ) : ( <div></div> )
                         }
                       </div>
                     ) : ( <div></div> )
                  }
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    { (this.state.ordertype == 'save' || this.state.ordertype == 'quotation') ?
                      (<div></div>):
                      (
                        <div> Payment Mode<br/>
                          <datalist id="suggestions2">
                              {this.props.paymentmode.map((x) => {
                                return ( <option id='box2'>{x.id+'->'+x.mode}</option> )
                              })}
                          </datalist>
                          <input style={{height: 35, width: '100%'}} onChange={this.paymentdropdown} autoComplete="on"
                          list="suggestions2" value={this.state.selectedValue}/>
                          <Radio checked={this.state.selectedValue === 'Credit'} onChange={this.handleChangeselect}  value="Credit" name="radio-button-demo" aria-label="Credit" />Credit
                          <Radio checked={this.state.selectedValue === 'Online'} onChange={this.handleChangeselect}  value="Online" name="radio-button-demo" aria-label="Online" />Online<br/>
                          <b>Sales Type</b><br/>
                          <Dropdown fluid search onChange={this.selectedSalesType} selection options={salesTypeOption} value={this.state.salesType} />
                        </div>
                      )
                    }
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <Button fluid onClick={ () => { this.setState({ remark: false, customerpoint: 0 }) }}>Cancel</Button>
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <Button fluid onClick={this.generateQuatationAndInvoice.bind(this, this.state.ordertype)}>Conform</Button>
                  </Grid.Column>
                </Grid>
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
        <Followup open={this.state.followup}   close={ () => { this.setState({ followup: false }) }}
          updatefollowupDetails={this.updatefollowupDetails.bind(this)} />
      </div>
    );
  }
}

FullScreenDialog.propTypes = { classes: PropTypes.object.isRequired, };

export default withStyles(styles)(FullScreenDialog);
